module.exports = __webpack_public_path__ + "img/subjectobject.8f1e0a4b.png";